module.exports = __webpack_public_path__ + "web/img/mvp-img1.24d5792a.png";